import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2aa1edb8"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2aa1edb8')) {
      api.createRecord('2aa1edb8', component.options)
    } else {
      api.reload('2aa1edb8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2aa1edb8", function () {
      api.rerender('2aa1edb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/template/dataSourceManage/index.vue"
export default component.exports